import { render, staticRenderFns } from "./CalendarWork.vue?vue&type=template&id=21a8f732&scoped=true&"
import script from "./CalendarWork.vue?vue&type=script&lang=js&"
export * from "./CalendarWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a8f732",
  null
  
)

export default component.exports